import React, { useRef } from 'react';
import './OnPropertyBiggerMoments.css';
import OptimizedImage from './OptimizedImage';
import waysToGoFurtherImage from 'url:../../assets-optimized/redesign/solutions/on-property/waysToGoFurther.jpg';
import waysToGoFurtherImageavif from 'url:../../assets-optimized/redesign/solutions/on-property/waysToGoFurther.avif';
import waysToGoFurtherImagewebp from 'url:../../assets-optimized/redesign/solutions/on-property/waysToGoFurther.webp';
import ActionButton from '../elements/ActionButton/ActionButton';

const ArrowDownIcon = () => (
  <svg viewBox='0 0 24 24' fill='none' aria-hidden='true'>
    <path
      d='M12 4V20M12 20L6 14M12 20L18 14'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const OnPropertyBiggerMoments = () => {
  const contentRef = useRef(null);
  const scrollToContent = () => {
    if (contentRef.current) {
      const yOffset = -60; // 60px offset for sticky header, tweak if needed
      const elementPosition = contentRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY + yOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className='op-bigger-moments-section'>
      <div className='op-bm-header'>
        <h2 className='op-bm-title'>BUILT FOR BIGGER MOMENTS</h2>
        <p className='op-bm-subtitle'>
          For brands looking to go beyond placements, we create what travelers remember through
          culture and experience. We can unlock incremental revenue opportunities and evolve hotels
          into assets that deliver measurable ROI and enhanced guest experiences.
        </p>
        <div className='op-bm-arrow-wrapper'>
          <button
            className='op-bm-arrow-circle'
            onClick={scrollToContent}
            style={{ cursor: 'pointer', background: 'transparent' }}
            aria-label='Scroll to details'
          >
            <ArrowDownIcon />
          </button>
        </div>
      </div>

      <div className='op-bm-content' ref={contentRef}>
        <div className='op-bm-left-card'>
          <OptimizedImage
            className='op-bm-left-image'
            avif={waysToGoFurtherImageavif}
            webp={waysToGoFurtherImagewebp}
            fallback={waysToGoFurtherImage}
            alt='Ways to go further background'
          />
          <div className='op-bm-left-overlay'>
            <h3 className='op-bm-left-title'>WAYS TO GO FURTHER</h3>
            <div className='op-bm-left-actions'>
              <ActionButton to='/contact' text='Contact Us' />
            </div>
          </div>
        </div>

        <div className='op-bm-right-column'>
          <div className='op-bm-card op-bm-card--orange'>
            <div className='op-bm-card-main'>
              <div className='op-bm-card-number'>01</div>
              <div className='op-bm-card-text'>
                <h4 className='op-bm-card-title'>
                  CURATED <br className='desktop-only' />
                  NATIONAL CAMPAIGNS
                </h4>
                <p className='op-bm-card-desc'>
                  Scale your message across the full traveler journey with coordinated, high-impact
                  placements.
                </p>
              </div>
            </div>
            <div className='op-bm-card-badge'>AVAILABLE NOW</div>
          </div>

          <div className='op-bm-card op-bm-card--blue'>
            <div className='op-bm-card-main'>
              <div className='op-bm-card-number'>02</div>
              <div className='op-bm-card-text'>
                <h4 className='op-bm-card-title'>
                  CULTURAL & SEASON <br className='desktop-only' />
                  EVENT TAKEOVERS
                </h4>
                <p className='op-bm-card-desc'>
                  Show up in the motivational moments either it be seasonal or cultural. Explore
                  hotel-wide digital screen takeovers tied to major events.
                </p>
              </div>
            </div>
            <div className='op-bm-card-badge'>COMING SOON (2026)</div>
          </div>

          <div className='op-bm-card op-bm-card--black'>
            <div className='op-bm-card-main'>
              <div className='op-bm-card-number'>03</div>
              <div className='op-bm-card-text'>
                <h4 className='op-bm-card-title'>EXPERIENTIAL COMPONENTS</h4>
                <p className='op-bm-card-desc'>
                  Bring your brand into the physical world through curated, on-property experiences.
                </p>
              </div>
            </div>
            <div className='op-bm-card-badge'>COMING SOON (2026)</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnPropertyBiggerMoments;
